import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';

import { ModalModule } from 'ngx-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GrowlModule } from 'primeng/primeng';
import { HttpClientModule } from '@angular/common/http';
import { FileViewerComponent } from './file-viewer/file-viewer.component';
import { TableComponentComponent } from './table-component/table-component.component';
import { ModalFormComponent } from './modals/modal-form-template/modal-form.component';
import { Select2Module } from 'ng2-select2';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { QuillModule } from 'ngx-quill';
import { AgentModalComponent } from './modals/agent-modal/agent-modal.component';
import { AdvancedFilterComponent } from './advanced-filter/advanced-filter.component';
import { OptionViewComponent } from './table-component/option-view/option-view.component';
import { InfiniteSelectComponent } from './infinite-select/infinite-select.component';
import { MergeModalComponent } from './modals/merge-modal/merge-modal.component';
import { DownloadComponent } from './process/download/download.component';
import { UploadComponent } from './process/upload/upload.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ModalModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    GrowlModule,
    BrowserModule,
    HttpClientModule,
    Select2Module,
    BsDatepickerModule.forRoot(),
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    QuillModule,
  ],
  declarations: [
    FileViewerComponent,
    TableComponentComponent,
    ModalFormComponent,
    AgentModalComponent,
    AdvancedFilterComponent,
    OptionViewComponent,
    MergeModalComponent,
    DownloadComponent,
    UploadComponent,
    InfiniteSelectComponent,
  ],
  exports: [
    FileViewerComponent,
    TableComponentComponent,
    ModalFormComponent,
    AgentModalComponent,
    OptionViewComponent,
    AdvancedFilterComponent,
    MergeModalComponent,
    DownloadComponent,
    InfiniteSelectComponent,
  ],
  providers: [],
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/app/components/component.module.ts